module.exports = __webpack_public_path__ + "img/kia-logo-white.c2617fcb.png";